// src/pages/Contact.jsx
import React, { useState } from "react";
import { API_BASE_URL } from "../config";


export default function Contact() {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });
  const [status, setStatus] = useState({ type: "", message: "" });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: "", message: "" });
    setSubmitting(true);

    try {
      const res = await fetch(`${API_BASE_URL}/api/contact`, {

        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json();

      if (!res.ok) throw new Error(data.message || "Failed to send message");

      setStatus({
        type: "success",
        message: "Thank you for your message.",
      });
      setForm({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        message: "",
      });
    } catch (err) {
      setStatus({
        type: "error",
        message: err.message || "Something went wrong. Please try again.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-6xl mx-auto px-4 py-12 grid gap-10 lg:grid-cols-[2fr,1fr]">
      {/* Form column */}
      <section className="bg-white rounded-2xl shadow-soft border p-8">
        <h1 className="text-2xl sm:text-3xl font-extrabold text-ink mb-2 text-center sm:text-left">
          Contact Us
        </h1>
        <p className="text-ink/70 mb-6 text-center sm:text-left">
          Fill in the form below to send us a message about the Women & Girls in
          STEM After-School Club.
        </p>

        {status.message && (
          <p
            className={`mb-4 text-sm font-medium ${
              status.type === "success" ? "text-green-700" : "text-red-600"
            }`}
          >
            {status.message}
          </p>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          <div className="grid gap-4 sm:grid-cols-2">
            <div>
              <label
                htmlFor="firstName"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                First Name<span className="text-red-500">*</span>
              </label>
              <input
                id="firstName"
                name="firstName"
                type="text"
                value={form.firstName}
                onChange={handleChange}
                required
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-brand-500 focus:outline-none"
              />
            </div>

            <div>
              <label
                htmlFor="lastName"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Last Name<span className="text-red-500">*</span>
              </label>
              <input
                id="lastName"
                name="lastName"
                type="text"
                value={form.lastName}
                onChange={handleChange}
                required
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-brand-500 focus:outline-none"
              />
            </div>
          </div>

          <div className="grid gap-4 sm:grid-cols-2">
            <div>
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Email Address<span className="text-red-500">*</span>
              </label>
              <input
                id="email"
                name="email"
                type="email"
                value={form.email}
                onChange={handleChange}
                required
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-brand-500 focus:outline-none"
              />
            </div>

            <div>
              <label
                htmlFor="phone"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Phone Number
              </label>
              <input
                id="phone"
                name="phone"
                type="tel"
                value={form.phone}
                onChange={handleChange}
                placeholder="+353 ..."
                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-brand-500 focus:outline-none"
              />
            </div>
          </div>

          <div>
            <label
              htmlFor="message"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Your Message<span className="text-red-500">*</span>
            </label>
            <textarea
              id="message"
              name="message"
              rows="5"
              value={form.message}
              onChange={handleChange}
              required
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-brand-500 focus:outline-none resize-none"
            />
          </div>

          <button
            type="submit"
            disabled={submitting}
            className="w-full rounded-xl bg-brand-500 text-white font-semibold py-3 mt-2 hover:bg-brand-600 disabled:opacity-60 disabled:cursor-not-allowed transition-colors"
          >
            {submitting ? "Sending..." : "Send Message"}
          </button>
        </form>
      </section>

      {/* Info column */}
      <aside className="space-y-4 text-sm text-ink/80">
        <div className="bg-white rounded-2xl shadow-soft border p-6">
          <h2 className="text-base font-semibold text-ink mb-2">
            Contact Details
          </h2>
          <p>
            <span className="font-medium">Email:</span>{" "}
            <a
              href="mailto:hope.boyle@mu.ie"
              className="text-brand-700 hover:underline"
            >
              hope.boyle@mu.ie
            </a>
          </p>
          <p className="mt-1">
            <span className="font-medium">Phone:</span> (01) 708 6000
          </p>
          <p className="mt-4 text-xs text-ink/70">
            We aim to respond to all messages as soon as possible.
          </p>
        </div>
      </aside>
    </div>
  );
}
